export class LoginByTokenReq {
	public token: string;

	public clone(token: string): LoginByTokenReq {
		if (token !== null) {
			this.token = token;
		}

		return this;
	}

	public convert(): any {
		return {
			token: this.token,
		};
	}
}
